import { random } from "lodash";
import { LineItemType, PurchaseRule, PurchaseRuleLink } from "types";

export const getSequence = (lineItemType: LineItemType) => {
    // We can safely use random numbers for some line item types,
    // as long as they are in the correct range

    if (lineItemType === LineItemType.TAX) {
        return random(80_000_001, 89_999_999);
    }

    if (lineItemType === LineItemType.FEE) {
        return random(60_000_001, 69_999_999);
    }

    if (lineItemType === LineItemType.AFFILIATE_DISCOUNT) {
        return 40_500_000;
    }

    if (lineItemType === LineItemType.AFFILIATE_DISCOUNT_OVERRIDE) {
        return 40_550_000;
    }

    if (lineItemType === LineItemType.AFFILIATE_COMMISSION) {
        return 90_100_000;
    }

    if (lineItemType === LineItemType.AFFILIATE_COMMISSION_OVERRIDE) {
        return 91_000_000;
    }

    return 0;
};

export const getPurchaseRulesFromPurchaseRuleLink = (purchaseRuleLink?: PurchaseRuleLink): PurchaseRule[] => {
    const purchaseRules: PurchaseRule[] = [];
    if (purchaseRuleLink?.purchaseRules) {
        for (const purchaseRule of purchaseRuleLink.purchaseRules) {
            if (purchaseRule.purchaseRule) {
                purchaseRules.push(purchaseRule.purchaseRule as PurchaseRule);
            }
        }
    }

    return purchaseRules;
};

export const getPurchaseRulesFromPurchaseRuleLinks = (purchaseRuleLinks: PurchaseRuleLink[]): PurchaseRule[] => {
    const purchaseRules: PurchaseRule[] = [];
    for (const purchaseRuleLink of purchaseRuleLinks) {
        purchaseRules.push(...getPurchaseRulesFromPurchaseRuleLink(purchaseRuleLink));
    }

    return purchaseRules;
};

export const getExistingPurchaseRule = (purchaseRuleLinks: PurchaseRuleLink[], purchaseRule?: PurchaseRule) => {
    return purchaseRuleLinks.find(
        (purchaseRuleLink) =>
            (purchaseRuleLink.purchaseRules[0].purchaseRule as PurchaseRule)?.meta?.subProductId ===
            purchaseRule?.meta?.subProductId,
    );
};
